import React from "react";
import PropTypes from "prop-types";
import MDialog, { ACTION_CLOSE } from "components/Shared/MDialog.tsx";
import { MSpinner } from "components/Shared";
import { Button } from "react-md";
import { ASSIGNMENT_MODE_APPRAISAL, ASSIGNMENT_MODE_INSURANCE } from "components/Assignment";

const CaseAssignment = ({
  insuranceCaseCount,
  appraisalCaseCount,
  visible,
  hideDialog,
  openAssignment
}) => {
  let dialogText;
  const noCasesForAssignment = "There are no cases in this quicklist that are avaiable for assignment";
  const assignTo = "Assign to";

  const hasAppraisalCases = appraisalCaseCount > 0;
  const hasInsuranceCases = insuranceCaseCount > 0;

  if (insuranceCaseCount === null || appraisalCaseCount === null) {
    dialogText = <MSpinner />;
  } else if (hasInsuranceCases && hasAppraisalCases) {
    dialogText = "Who would you like to assign to?";
  } else if (hasAppraisalCases) {
    dialogText = `${noCasesForAssignment} to field representatives. ${assignTo}`;
  } else if (hasInsuranceCases) {
    dialogText = `${noCasesForAssignment} to appraisers. ${assignTo}`;
  } else {
    dialogText = noCasesForAssignment + ".";
  }

  return (
    <MDialog
      id="case-assignment-dialog"
      title="Open in Assignment Tool"
      actions={[{ code: ACTION_CLOSE, onClick: hideDialog }]}
      contentActions={[
        <Button key="loadAssignmentToolAppraisal" primary raised disabled={!hasAppraisalCases} onClick={() => openAssignment(ASSIGNMENT_MODE_APPRAISAL)} >Appraisers</Button>,
        <Button key="loadAssignmentToolInsurance" primary raised disabled={!hasInsuranceCases} onClick={() => openAssignment(ASSIGNMENT_MODE_INSURANCE)} >Field Representatives</Button>
      ]}
      visible={visible}
    >
      <p>{dialogText}</p>
    </MDialog>
  );
};

CaseAssignment.propTypes = {
  insuranceCaseCount: PropTypes.number, // Count of insurance cases
  appraisalCaseCount: PropTypes.number,  // Count of appraisal cases
  visible: PropTypes.bool.isRequired, // Show/hide the dialog
  hideDialog: PropTypes.func.isRequired,  // Function that will set visibility to false
  openAssignment: PropTypes.func.isRequired,  // Function that will be passed the assignment mode and will push the correct assignment path to history
};

CaseAssignment.defaultProps = {
  insuranceCaseCount: 0,
  appraisalCaseCount: 0,
  visible: false,
};

export default CaseAssignment;